import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomerUsersService } from '../../services/customerUsers.service';
import { Right } from '../../services/dtos/right';
import { Role } from '../../services/dtos/role';
import { RolesService } from '../../services/roles.service';
import { AddRole, DeleteRole, FetchAllRightsIfEmpty, FetchAllRoles, UpdateRole } from './adminRoles.actions';

export class AdminRolesStateModel {
    public roles!: Role[];
    public rights!: Right[];
}

const defaults = {
    roles: [],
    rights: []
};

@State<AdminRolesStateModel>({
    name: 'adminRolesState',
    defaults
})

@Injectable()
export class AdminRolesState {
    public constructor(private rolesService: RolesService, private customerUsersService: CustomerUsersService) { }

    @Selector()
    public static getRoles(state: AdminRolesStateModel): Role[] {
        return state.roles;
    }

    @Selector()
    public static getRights(state: AdminRolesStateModel): Right[] {
        return state.rights;
    }

    @Action(FetchAllRightsIfEmpty)
    public fetchAllRights({ getState, setState }: StateContext<AdminRolesStateModel>): Observable<Right[]> | void {
        if (getState().rights.length === 0) {
            return this.customerUsersService.getAllRights()
                .pipe(
                    tap((rights: Right[]) => {
                        const state = getState();
                        setState({ ...state, rights });
                    })
                );
        }
    }

    @Action(FetchAllRoles)
    public fetchAll({ getState, setState }: StateContext<AdminRolesStateModel>): Observable<Role[]> {
        return this.rolesService.getAll()
            .pipe(
                tap((roles: Role[]) => {
                    const state = getState();
                    setState({ ...state, roles });
                })
            );
    }

    @Action(UpdateRole)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty-pattern
    public update({ }: StateContext<AdminRolesStateModel>, { payload }: UpdateRole): Observable<any> {
        return this.rolesService.updateRole(payload);
    }

    @Action(DeleteRole)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty-pattern
    public delete({ }: StateContext<AdminRolesStateModel>, { id }: DeleteRole): Observable<any> {
        return this.rolesService.deleteRole(id);
    }

    @Action(AddRole)
    // eslint-disable-next-line no-empty-pattern
    public add({ }: StateContext<AdminRolesStateModel>, { payload }: AddRole): Observable<string> {
        return this.rolesService.addRole(payload);
    }
}
